import type { DataTableColumn, SearchColumnDef } from '@/components/custom/erp';
import { Checkbox } from '@/components/ui/checkbox';
import type { KhoHang } from '@/types/schemas';

interface WarehouseInventoryRow {
  warehouse_code: string;
  item_code: string;
  item_name: string;
  unit: string;
  ending_balance: number;
}

export const warehouseColumns = (): DataTableColumn<KhoHang>[] => [
  { field: 'ma_kho', headerName: 'Mã kho', width: 120 },
  { field: 'ten_kho', headerName: 'Tên kho', width: 200 },
  {
    field: 'vi_tri_yn',
    headerName: 'Theo dõi vị trí',
    width: 150,
    renderCell: params => {
      return (
        <div className='flex h-full w-full items-center justify-center'>
          <Checkbox checked={params.value === true || params.value === 1} disabled />
        </div>
      );
    }
  },
  { field: 'dia_chi', headerName: 'Địa chỉ', width: 200 },
  { field: 'ma_unit', headerName: 'Đơn vị', width: 150 }
];

export const companyColums: SearchColumnDef[] = [
  {
    field: 'ma_unit',
    headerName: 'Mã Đơn vị',
    width: 120
  },
  {
    field: 'ten_unit',
    headerName: 'Tên Đơn vị',
    width: 200
  },
  {
    field: 'unit_id',
    headerName: 'ID',
    width: 200
  }
];

export const inventoryColumns = (): DataTableColumn<WarehouseInventoryRow>[] => [
  { field: 'warehouse_code', headerName: 'Mã kho', width: 120 },
  { field: 'item_code', headerName: 'Mã vật tư', width: 120 },
  { field: 'item_name', headerName: 'Tên vật tư', width: 200 },
  { field: 'unit', headerName: 'Đvt', width: 80 },
  { field: 'ending_balance', headerName: 'Tồn cuối', width: 120 }
];
